import React from 'react';

/**
 * Cheapo AI Official Logo Component
 * High-resolution SVG recreation preserving exact branding, colors, and tagline.
 */
export default function Logo({ className = '', height }) {
  const style = height ? { height: `${height}px`, width: 'auto' } : {};

  return (
    <svg 
      viewBox="0 0 420 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={`block ${className}`} 
      style={style}
    >
      {/* Icon Group */}
      <g transform="translate(10, 10)">
        {/* Sparkles */}
        <path d="M12 -4 Q12 6 22 6 Q12 6 12 16 Q12 6 2 6 Q12 6 12 -4 Z" fill="#2563EB" transform="translate(0, 0) scale(1)"/>
        <path d="M12 -4 Q12 6 22 6 Q12 6 12 16 Q12 6 2 6 Q12 6 12 -4 Z" fill="#2563EB" transform="translate(28, -8) scale(0.7)"/>
        <path d="M12 -4 Q12 6 22 6 Q12 6 12 16 Q12 6 2 6 Q12 6 12 -4 Z" fill="#2563EB" transform="translate(-8, 28) scale(0.8)"/>

        {/* Magnifying Glass Ring */}
        <circle cx="42" cy="42" r="24" stroke="#2563EB" strokeWidth="8" />

        {/* Magnifying Glass Handle */}
        <line x1="59" y1="59" x2="78" y2="78" stroke="#2563EB" strokeWidth="10" strokeLinecap="round" />

        {/* Price Tag Inside */}
        <g transform="translate(42, 42) rotate(-45)">
          <path d="M0,-11 L9,-2 L9,13 L-9,13 L-9,-2 Z" fill="#2563EB" />
          <circle cx="0" cy="-3.5" r="2.5" fill="#ffffff" />
          <rect x="-4" y="2.5" width="8" height="2" rx="1" fill="#ffffff" />
          <rect x="-4" y="7" width="5" height="2" rx="1" fill="#ffffff" />
        </g>
      </g>

      {/* Branding Text */}
      <text x="110" y="58" fontFamily="Inter, system-ui, sans-serif" fontSize="48" fontWeight="800" letterSpacing="-1.5">
        <tspan fill="#111827">Cheapo</tspan>
        <tspan fill="#2563EB">AI</tspan>
      </text>

      {/* Tagline */}
      <text x="114" y="82" fontFamily="Inter, system-ui, sans-serif" fontSize="16" fontWeight="500" fill="#4B5563" letterSpacing="0.2">
        Find the Best Price, Instantly.
      </text>
    </svg>
  );
}